import { createSelector } from '@reduxjs/toolkit';

import { ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { generateDataItem } from '@app/helpers/artifacts/generateDataItem';
import { type SingleDisplayItem } from '@app/store/types/artifacts';

export function celestialRosesSelector(state) {
    const { artifactMetadata } = state.artifacts;
    const roseItemsMetadata = artifactMetadata
        ? artifactMetadata.filter((item) => item.artifact_type === ArtifactType.CelestialRose && item.main_id?.length)
        : [];

    const celestialRoseDisplayItems: SingleDisplayItem[] = roseItemsMetadata.map((rose) => {
        return generateDataItem().displayMetadata(rose);
    });
    celestialRoseDisplayItems.sort((a, b) => parseInt(a.token_id) - parseInt(b.token_id));
    return celestialRoseDisplayItems;
}

export function userCelestialRosesSelector(state) {
    const { artifactMetadata, userArtifacts } = state.artifacts;

    const roseItemsMetadata =
        artifactMetadata && artifactMetadata.filter((item) => item.artifact_type === ArtifactType.CelestialRose);

    const userRoseItems = userArtifacts?.CelestialRose;

    const userRoseIds = (userRoseItems && generateDataItem().ownedIds(userRoseItems)) || [];

    const userRoseItemMetadata: SingleDisplayItem[] = [];
    userRoseIds.forEach((roseId) => {
        const rose = roseItemsMetadata?.find((roseItemMetadata) => roseItemMetadata.main_id === roseId) || [];
        if (rose?.metadata) {
            userRoseItemMetadata.push(generateDataItem().displayMetadata(rose));
        }
    });
    userRoseItemMetadata.sort((a, b) => parseInt(a.token_id) - parseInt(b.token_id));
    return userRoseItemMetadata;
}

export const firstCelestialRoseSelector = createSelector(
    celestialRosesSelector,
    userCelestialRosesSelector,
    (celestialRoses, userRoses) => {
        return (userRoses && userRoses[0]) || (celestialRoses && celestialRoses[0]);
    },
);

export const combinedRoseSelector = createSelector(
    celestialRosesSelector,
    userCelestialRosesSelector,
    (celestialRoses, userRoses) => {
        const filtered = celestialRoses.filter((rose) => !userRoses.find((cr) => cr.id === rose.id));
        return [...userRoses, ...filtered];
    },
);

export const filteredRoseSelector = createSelector(
    celestialRosesSelector,
    userCelestialRosesSelector,
    (celestialRoses, userRoses) => {
        return celestialRoses.filter((rose) => !userRoses.find((cr) => cr.id === rose.id));
    },
);
